// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"right-inner__wrap--25x_H","white":"right-inner__white--kn32K"};